export const toHalfWidth = (s: string): string =>
  s.replace(/[！-～]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xfee0))

export const normalizePhone = (s: string): string => toHalfWidth(s).replace(/-/g, '')

export const normalizeEmail = (s: string): string => toHalfWidth(s).toLowerCase()

/**
 * entryInstructionTime ("yyyy-MM-dd HH:mm" or "yyyy-MM-dd HH:mm:ss") を date / time に分解。
 * 不正な値や null/undefined のときは空文字を返す。
 */
export const splitEntryInstructionTime = (
  iso: string | null | undefined
): { date: string; time: string } => {
  if (!iso) return { date: '', time: '' }
  const match = iso.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})/)
  if (!match) return { date: '', time: '' }
  return { date: match[1], time: match[2] }
}

/**
 * date (YYYY-MM-DD) + time (HH:mm) を BE が期待する "yyyy-MM-dd HH:mm" 形式に結合。
 * どちらかが欠けていれば null を返す。
 */
export const combineEntryInstructionTime = (date: string, time: string): string | null => {
  if (!date || !time) return null
  return `${date} ${time}`
}
